export function randomBunchId() {
    return `${new Date().getMilliseconds()}-${Math.random() * 10000}`;
}

export default randomBunchId;
